import {Component, OnInit} from '@angular/core';
import {DidgigoApiService} from '@didgigo/lib-angular';
import {ApiAgency, Company, CompanySummary, User} from '@didgigo/lib-ts';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Either, None, Option, Some} from 'funfix-core';
import {List} from 'immutable';
import {Observable} from 'rxjs';
import {ApiConnectionService} from '../../services/api-connection.service';
import {ToastHandlerService} from '../../services/toast-handler-service';

@Component({
  selector: 'app-add-agent-modal',
  templateUrl: './add-agent-modal.component.html',
  styleUrls: ['./add-agent-modal.component.scss']
})
export class AddAgentModalComponent implements OnInit {

  constructor(
    readonly apiConnection: ApiConnectionService,
    readonly modalService: NgbActiveModal,
    readonly api: DidgigoApiService,
    readonly notificationService: ToastHandlerService,
  ) {
  }

  companies: List<Company> = List();

  loading: boolean;

  login = '';
  password = '';

  selectedCompany: Option<Company> = None;

  addAgentCompanyApiMapping(): void {
    const apiAgency = ApiAgency.forAgentCompanyMapping(
      this.getLogin(),
      this.getPassword(),
      this.apiConnection.getCurrentUsingAsCompany(),
      this.selectedCompany,
    );
    Option.map2(this.getCurrentConnectionId(), this.getCurrentUserName(), async (connId, modifiedBy) => {
      const request = await this.api.createApiCompanyAgentMapping(apiAgency, connId, modifiedBy);
      if (request.isLeft()) {
        this.notificationService.showError('Error', request.value);
        return;
      }
      this.notificationService.showSuccess('Success', 'Successfully created agency');
      this.apiConnection.agencies.next(this.getApiAgencies().concat(apiAgency));
    });
  }

  agencyNameExtractor = (c: Company) => c.getName();

  companyLabeller = (c: Company) => c.getName().getOrElse('Company Name');

  getApiAgencies(): List<ApiAgency> {
    return this.apiConnection.agencies.getValue();
  }

  getAvailableCompanies(): Observable<List<Company>> {
    this.loading = true;
    return this.apiConnection.listProposalCompanies();
  }

  getCompanyImage(): Option<string> {
    return this.selectedCompany
      .flatMap(x => x.getLogo())
      .flatMap(x => x.getUri())
      .map(x => x.getFileName());
  }

  getCurrentConnectionId(): Option<number> {
    return this.apiConnection.selectedState
      .getValue()
      .getConnection()
      .flatMap(x => x.getId());
  }

  getCurrentConnectionLabel(): Option<string> {
    return this.apiConnection.selectedState
      .getValue()
      .getConnection()
      .flatMap(x => x.getLabel());
  }

  getCurrentCountryState(): Option<string> {
    return this.selectedCompany
      .flatMap(x => x.getLocation())
      .flatMap(x => x.getState());
  }

  getCurrentUser(): Option<User> {
    return this.apiConnection.selectedState
      .getValue()
      .getUser();
  }

  getCurrentUserName(): Option<string> {
    return this.getCurrentUser()
      .flatMap(u => u.getLoggedInAgentName());
  }

  getLogin(): Option<string> {
    return Option.of(this.login);
  }

  getPassword(): Option<string> {
    return Option.of(this.password);
  }

  ngOnInit(): void {
    this.getAvailableCompanies()
      .subscribe(cs => {
        this.companies = cs;
        this.loading = false;
      });
  }

  updateSelectedCompany(event: Company): void {
    this.selectedCompany = Some(event);
  }

}
